import $ from 'jquery';

$.addInit(function(context) {
	var base = '.b-customFile';

	$(base, context).each(function() {
		var component = $(this);
		var fileInput = component.find(base + '-input');
		var format = component.find(base + '-format');
		var formatText = format.text();
		var form = component.closest('.b-form');
		var field_fileInput = form.find('.b-form-row_upload .b-form-field');

		var localeFileInput = document.documentElement.lang || 'ru';

		var messagesFileInput = {
			'ru': {
				delete: 'Удалить',
				sizeError: 'Файл превышает допустимый размер 2 мегабайта',
				formatError: 'Файл имеет недопустимый формат. Принимаются файлы в форматах JPG и PNG.',
				formatDocError: 'Файл имеет недопустимый формат. Принимаются файлы в форматах PDF, DOC и DOCX.',
			},
			'en': {
				delete: 'Remove',
				sizeError: 'The file exceeds the allowed size of 2 Mb',
				formatError: 'The file has an invalid format. Files in JPG and PNG formats are accepted.',
				formatDocError: 'The file has an invalid format. Files in PDF, DOC and DOCX formats are accepted.',
			},
			'ua': {
				delete: 'Видалити',
				sizeError: 'Файл перевищує допустимий розмір 2 Мб',
				formatError: 'Файл має неприпустимий формат. Приймаються файли у форматах JPG і PNG.',
				formatDocError: 'Файл має неприпустимий формат. Приймаються файли у форматах PDF, DOC i DOCX.',
			},
			'lt': {
				delete: 'Pašalinti',
				sizeError: 'Failas viršija leistinas dydis 2 Mb',
				formatError: 'Failas yra neteisingas formatas. Priimami formatų failus JPG ir PNG.',
				formatDocError: 'Failas yra neteisingas formatas. Priimami formatų failus PDF, DOC ir DOCX.',
			},
			'st': {
				delete: 'Eemaldama',
				sizeError: 'Fail ületab lubatud suurus on 2 Mb',
				formatError: 'Fail on vigane formaat. Vastu võetakse faile JPG ja PNG.',
				formatDocError: 'Fail on vigane formaat. Vastu võetakse faile PDF, DOC ja DOCX.',
			},
			'lv': {
				delete: 'Noņemt',
				sizeError: 'Fails pārsniedz pieļaujamo izmērs 2 Mb',
				formatError: 'Fails ir nederīgs formāts. Tiek pieņemti failus JPG un PNG.',
				formatDocError: 'Fails ir nederīgs formāts. Tiek pieņemti failus PDF, DOC un DOCX.',
			},
		};

		var messages = messagesFileInput[localeFileInput] || messagesFileInput['en'];

		fileInput.on('change', function(e) {
			// console.log('change', this.files);

			if (this.files.length > 0) {
				var inputSize = Math.ceil(this.files[0].size / 1024 / 1024);
				var fileName = '';
				fileName = e.target.value.split('\\').pop();

				var ext = this.files[0].name.replace(/.*\./, '');
				var type = this.files[0].type;
				var types = (type === 'image/png' || type === 'image/jpg' || type === 'image/jpeg');
				var typesDoc = (type === 'application/pdf' || type === 'application/msword' || ext === 'docx');

				if (fileName && inputSize <= 2) {
					var item = $('<div>', { 'class': 'b-customFile-content' });

					if (types) {
						$('<img>', {'class': 'b-customFile-img', 'src': URL.createObjectURL(e.target.files[0])}).appendTo(item);
					}

					if (typesDoc) {
						format.text(e.target.files[0].name);
					}

					var deleteButton = $('<button>', {'class': 'b-customFile-fileDelete', 'text': messages.delete }).appendTo(item);
					deleteButton.on('click', function(e) {
						e.preventDefault();
						item.remove();
						fileInput.val('').trigger('input');
						format.text(formatText);
					});

					var content = component.find(base + '-content');
					if (content) {
						content.remove();
					}

					item.appendTo(component);
				} else {
					fileInput.val('').trigger('input');
					$('.b-customFile-content').remove();
				}

				if (inputSize > 2) {
					setTimeout(function() {
						field_fileInput.toggleClass('m-error', inputSize > 2).find('.b-form-error').text(inputSize > 2 ? messages.sizeError : '');
					});
				}

				if (!types && !(typesDoc === true)) {
					setTimeout(function() {
						field_fileInput.toggleClass('m-error', !types).find('.b-form-error').text(!types ? messages.formatError : '');
					});
				}

				if (!typesDoc && !(types === true)) {
					setTimeout(function() {
						field_fileInput.toggleClass('m-error', !typesDoc).find('.b-form-error').text(!typesDoc ? messages.formatDocError : '');
					});
				}
			} else {
				fileInput.val('').trigger('input');
				component.find('.b-customFile-content').remove();
			}
		});
	});
});
